import React from "react";
import style from "./dialog.module.css";

const Dialog = ({
    isOpen,
    title
}) => {
    if (!isOpen) return null;

    return (
        <div
            className={[style.dialogView]}
        >
            <div className={style.loadingView}></div>
            {title ? <p>{title}</p> : null}
        </div>
    );
};

export default Dialog;